// extracted by mini-css-extract-plugin
export default {"container":"GeneralTab_container__b6m5s","tabContainer":"GeneralTab_tabContainer__v0leO","chartContainer":"GeneralTab_chartContainer__qR5Ny"};